import React from "react";
import { IconButton } from "@mui/material";
import Badge from "@mui/material/Badge";
import { Bell } from "@phosphor-icons/react";
import { useTheme } from "@emotion/react";

export default function NotificationBell({ unreadCount, onClick }) {
  const theme = useTheme();
  return (
    <IconButton onClick={onClick}>
      <Badge color="warning" variant="dot" invisible={unreadCount === 0}>
        <Bell weight="duotone" color={theme.palette.text.secondary} />
      </Badge>
    </IconButton>
  );
}
